import { useInfiniteQuery } from "@tanstack/react-query";
import { useApi } from "@/core/api";
import { useAuth } from "@/core/auth";
import type { ChangelogEntry } from "./entries";

interface ChangelogPageResponse {
  items: ChangelogEntry[];
  next_cursor: string | null;
  has_more: boolean;
}

export const useChangelog = () => {
  const api = useApi();
  const { user, isAuthenticated } = useAuth();

  return useInfiniteQuery({
    queryKey: ["changelog", user?.id, "cursor"],
    initialPageParam: null as string | null,
    queryFn: async ({ pageParam }) => {
      const { data } = await api.get<ChangelogPageResponse>(
        "/changelog_entries",
        {
          params: { cursor: pageParam ?? undefined, page_size: 20 },
        },
      );
      return data;
    },
    getNextPageParam: (page) => page.next_cursor ?? undefined,
    enabled: isAuthenticated,
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
};
